import React, { useContext, useMemo, useState, useEffect } from 'react';

import {
  UniversalPolygon,
  UniversalPolygonProps,
} from '@atlas/atoms/universal-polygon';
import { AtlasEventsContext } from '@atlas/contexts/events';

export const ParcelHighlighter = () => {
  const { on } = useContext(AtlasEventsContext);
  const [polygon, setPolygon] = useState<UniversalPolygonProps['polygon']>();

  useEffect(() => {
    on('parcelSelected', (parcel) =>
      setPolygon({ _id: parcel._id, ...parcel.polygon }),
    );
    on('searchChanged', (state) => {
      if (!state.parcel) {
        setPolygon(undefined);
      }
    });
  }, [on]);

  return useMemo(
    () => (polygon ? <UniversalPolygon polygon={polygon} /> : null),
    [polygon],
  );
};
